/** PURE_IMPORTS_START ._AjaxObservable PURE_IMPORTS_END */
import { AjaxObservable } from './AjaxObservable';
export var ajax = AjaxObservable.create;
//# sourceMappingURL=ajax.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/dom/ajax.js
// module id = 766
// module chunks = 0